// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeInput_inputRoot__1R86-","withMobileMargins":"DateRangeInput_withMobileMargins__ZuU8g","arrowIcon":"DateRangeInput_arrowIcon__26hZp"};